<template>
  <v-container fluid class="super-admin-dashboard">
    <v-row>
      <v-col cols="12">
          <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :top="snackbar.position === 'top'">
              <v-layout align-center pr-4>
              <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
              <v-layout column>
                  <div>
                  <strong>{{ snackbar.title }}</strong>
                  </div>
                  <div>{{ snackbar.text }}</div>
              </v-layout>
              </v-layout>
              <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
              <v-icon>clear</v-icon>
              </v-btn>
          </v-snackbar>
      </v-col>
    </v-row>
    <div class="d-flex align-center mb-4 px-1">
      <v-icon color="primary" class="mr-2">mdi-shield-crown</v-icon>
      <div>
        <div class="text-h6 font-weight-bold primary--text">Super Admin</div>
        <div class="caption grey--text text--darken-1">Kelola entity, role, menu, dan periode global</div>
      </div>
    </div>
    <v-card class="main-content">
      <v-tabs
        v-model="activeTab"
        class="setup-tabs"
        background-color="transparent"
        color="primary"
        slider-color="primary"
        slider-size="3"
        show-arrows
        center-active
      >
        <v-tab class="custom-tab">
          <v-icon left small>mdi-office-building</v-icon> Entity
        </v-tab>
        <v-tab class="custom-tab">
          <v-icon left small>mdi-account-multiple</v-icon> Role
        </v-tab>
        <v-tab class="custom-tab">
          <v-icon left small>mdi-format-list-bulleted</v-icon> Menu
        </v-tab>
        <v-tab class="custom-tab">
          <v-icon left small>mdi-cog</v-icon> Config
        </v-tab>
        <v-tab class="custom-tab">
          <v-icon left small>mdi-content-copy</v-icon> Cloning KPI
        </v-tab>
        <v-tab class="custom-tab">
          <v-icon left small>mdi-history</v-icon> Log Aktivitas
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <v-card flat>
            <v-card-title class="d-flex align-center">
              <v-btn color="warning" class="mr-4" @click="openDialog('entity')">
                <v-icon left>mdi-plus</v-icon> Tambah Entity
              </v-btn>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Cari Entity"
                outlined
                dense
                hide-details
                class="custom-search"
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="entityHeaders"
              :items="entities"
              :search="search"
              :loading="loading"
              class="custom-table"
            >
            <template v-slot:[`item.logo`]="{ item }">
              <v-avatar size="35" class="elevation-2">
                <v-img
                  :src="getLogoUrl(item.logo)"
                  :alt="item.name + ' logo'"
                  contain
                  :lazy-src="require('@/assets/logo.png')"
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-avatar>
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
              {{ new Date(item.created_at).toISOString().slice(0,10) }}
            </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small class="mr-2" v-bind="attrs" v-on="on" @click="Edit(item)">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit Entity</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small color="error" v-bind="attrs" v-on="on" @click="deleteItem(item)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Hapus Entity</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-title class="d-flex align-center">
              <v-icon color="primary" class="mr-2">mdi-shield-key-outline</v-icon>
              <span class="text-subtitle-1 font-weight-medium">Hak Akses Menu per Role</span>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="roleSearch"
                prepend-inner-icon="mdi-magnify"
                label="Cari menu"
                outlined
                dense
                hide-details
                clearable
                class="custom-search"
              ></v-text-field>
            </v-card-title>
            <div class="px-4 pb-2 caption grey--text">
              <v-icon x-small class="mr-1">mdi-information-outline</v-icon>
              Akses diatur per menu level atas — sub-menu di bawahnya otomatis ikut terbuka/tertutup mengikuti menu induknya.
            </div>
            <v-card-text class="pt-0">
              <div v-if="loadingMenus" class="text-center py-10">
                <v-progress-circular indeterminate color="primary" size="40"></v-progress-circular>
              </div>
              <div v-else class="role-matrix-wrapper">
                <table class="role-matrix">
                  <thead>
                    <tr>
                      <th class="role-matrix__menu-col">Menu</th>
                      <th v-for="role in roleOptions" :key="role" class="role-matrix__role-col">
                        {{ roleLabel(role) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="menu in menuTree"
                      :key="menu.id"
                      v-show="matchesSearch(menu, roleSearch)"
                    >
                      <td class="role-matrix__menu-col">
                        <v-icon small class="mr-2" color="primary">mdi-{{ menu.icon || 'circle-small' }}</v-icon>
                        <span>{{ menu.name }}</span>
                        <span v-if="menu.route" class="grey--text text-caption ml-1">{{ menu.route }}</span>
                        <span v-if="menu.children && menu.children.length" class="grey--text text-caption ml-1">
                          ({{ menu.children.map(c => c.name).join(', ') }})
                        </span>
                      </td>
                      <td v-for="role in roleOptions" :key="role" class="role-matrix__role-col">
                        <v-checkbox
                          :input-value="hasMenuRole(menu.id, role)"
                          :loading="togglingKey === (menu.id + '-' + role)"
                          :disabled="togglingKey === (menu.id + '-' + role)"
                          @change="val => toggleMenuRole(menu, role, val)"
                          dense
                          hide-details
                          class="role-matrix__checkbox ma-0 pa-0"
                        ></v-checkbox>
                      </td>
                    </tr>
                    <tr v-if="!menuTree.length">
                      <td :colspan="roleOptions.length + 1" class="text-center grey--text py-6">
                        Belum ada menu.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-title class="d-flex align-center">
              <v-btn color="primary" class="mr-4" @click="openAddMenu()">
                <v-icon left>mdi-plus</v-icon> Tambah Menu
              </v-btn>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="menuSearch"
                prepend-inner-icon="mdi-magnify"
                label="Cari Menu"
                outlined
                dense
                hide-details
                clearable
                class="custom-search"
              ></v-text-field>
            </v-card-title>
            <v-card-text>
              <div v-if="loadingMenus" class="text-center py-10">
                <v-progress-circular indeterminate color="primary" size="40"></v-progress-circular>
              </div>
              <div v-else-if="!menuTree.length" class="text-center grey--text py-10">
                <v-icon large color="grey lighten-1">mdi-menu</v-icon>
                <div class="mt-2">Belum ada menu.</div>
              </div>
              <div v-else class="menu-tree">
                <div class="caption grey--text mb-2">
                  <v-icon x-small class="mr-1">mdi-drag</v-icon>
                  Seret (drag) baris untuk mengatur urutan menu.
                </div>
                <div
                  v-for="(menu, idx) in menuTree"
                  :key="menu.id"
                  v-show="matchesSearch(menu, menuSearch)"
                >
                  <div
                    class="menu-tree__row"
                    draggable="true"
                    @dragstart="onDragStart(null, idx)"
                    @dragover.prevent
                    @drop.prevent="onDrop(null, idx)"
                  >
                    <v-icon class="menu-tree__handle" color="grey">mdi-drag</v-icon>
                    <v-icon class="mr-2" color="primary">mdi-{{ menu.icon || 'circle-small' }}</v-icon>
                    <span class="font-weight-medium">{{ menu.name }}</span>
                    <span v-if="menu.route" class="grey--text text-caption ml-2">{{ menu.route }}</span>
                    <v-chip x-small :color="menu.is_active ? 'green' : 'grey'" dark class="ml-2">
                      {{ menu.is_active ? 'Aktif' : 'Nonaktif' }}
                    </v-chip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small class="mr-1" v-bind="attrs" v-on="on" @click="openAddMenu(menu)">
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Tambah sub-menu</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small class="mr-1" v-bind="attrs" v-on="on" @click="openEditMenu(menu)">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit menu</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small color="error" v-bind="attrs" v-on="on" @click="askDeleteMenu(menu)">
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Hapus menu</span>
                    </v-tooltip>
                  </div>
                  <div v-if="menu.children && menu.children.length" class="menu-tree__children">
                    <div
                      v-for="(child, cIdx) in menu.children"
                      :key="child.id"
                      v-show="matchesSearch(child, menuSearch)"
                      class="menu-tree__row menu-tree__row--child"
                      draggable="true"
                      @dragstart.stop="onDragStart(menu.id, cIdx)"
                      @dragover.prevent
                      @drop.stop.prevent="onDrop(menu.id, cIdx)"
                    >
                      <v-icon class="menu-tree__handle" color="grey">mdi-drag</v-icon>
                      <v-icon class="mr-2" color="primary">mdi-{{ child.icon || 'circle-small' }}</v-icon>
                      <span>{{ child.name }}</span>
                      <span v-if="child.route" class="grey--text text-caption ml-2">{{ child.route }}</span>
                      <v-chip x-small :color="child.is_active ? 'green' : 'grey'" dark class="ml-2">
                        {{ child.is_active ? 'Aktif' : 'Nonaktif' }}
                      </v-chip>
                      <v-spacer></v-spacer>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon small class="mr-1" v-bind="attrs" v-on="on" @click="openEditMenu(child)">
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Edit menu</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon small color="error" v-bind="attrs" v-on="on" @click="askDeleteMenu(child)">
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Hapus menu</span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-col cols="12" class="pa-2">
              <v-card outlined class="rounded-lg config-section-card">
                <div class="d-flex align-center flex-wrap pa-4" style="gap:12px;">
                  <div class="flex-grow-1" style="min-width:260px;">
                    <div class="d-flex align-center" style="gap:8px;">
                      <span class="text-subtitle-1 font-weight-medium">Pengaturan Periode Input</span>
                      <v-chip v-if="entity" x-small label color="blue-grey lighten-5" class="blue-grey--text text--darken-2 font-weight-medium">
                        <v-icon left x-small>mdi-domain</v-icon>{{ entity.name }}
                      </v-chip>
                    </div>
                    <div class="caption grey--text text--darken-1 mt-1">
                      Jendela tanggal &amp; bulan aktif untuk pengisian KPI entity ini.
                    </div>
                  </div>
                  <v-btn color="cyan text-white" @click="openPeriodeDialog">
                    <v-icon left>mdi-pencil</v-icon> Ubah Pengaturan
                  </v-btn>
                </div>

                <v-divider></v-divider>

                <div class="pa-4">
                  <v-row dense>
                    <v-col v-for="item in settingCards" :key="item.key" cols="12" sm="4">
                      <div class="d-flex align-center pa-3 rounded-lg cyan lighten-5">
                        <v-icon color="cyan darken-2" size="28" class="mr-3">{{ item.icon }}</v-icon>
                        <div>
                          <div class="text-h6 font-weight-bold cyan--text text--darken-3" style="line-height:1.1;">
                            {{ item.display }}
                          </div>
                          <div class="caption grey--text text--darken-1">{{ item.label }}</div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" class="pa-2">
              <v-card outlined class="rounded-lg config-section-card">
                <div class="d-flex align-center flex-wrap pa-4" style="gap:12px;">
                  <div class="flex-grow-1" style="min-width:260px;">
                    <div class="d-flex align-center" style="gap:8px;">
                      <span class="text-subtitle-1 font-weight-medium">Buka Tahap Adjust Accounting</span>
                      <v-chip v-if="chartSummary" x-small label color="blue-grey lighten-5" class="blue-grey--text text--darken-2 font-weight-medium">
                        <v-icon left x-small>mdi-domain</v-icon>{{ chartSummary.entity.name }}
                      </v-chip>
                    </div>
                    <div class="caption grey--text text--darken-1 mt-1">
                      Pindahkan semua chart Published pada entity aktif yang punya KPI accounting
                      (top-level, bukan child/grandchild) ke status "Adjust Accounting".
                    </div>
                  </div>
                  <v-btn color="orange darken-2" dark :loading="loadingEligible" @click="openAccountingBulkDialog">
                    <v-icon left>mdi-calculator-variant</v-icon> Cari Chart Eligible
                  </v-btn>
                </div>

                <v-divider></v-divider>

                <div class="pa-4">
                  <div v-if="loadingSummary" class="d-flex align-center grey--text text-caption py-1">
                    <v-progress-circular indeterminate size="16" width="2" color="grey" class="mr-2"></v-progress-circular>
                    Memuat ringkasan status chart…
                  </div>
                  <div v-else-if="!chartSummary" class="grey--text text-caption py-1">
                    Ringkasan status chart tidak tersedia.
                  </div>
                  <v-row v-else dense>
                    <v-col v-for="stat in chartStatusStats" :key="stat.key" cols="12" sm="4">
                      <div class="d-flex align-center pa-3 rounded-lg" :class="`${stat.base} lighten-5`">
                        <v-icon :color="`${stat.base} darken-1`" size="28" class="mr-3">{{ stat.icon }}</v-icon>
                        <div>
                          <div class="text-h6 font-weight-bold" :class="`${stat.base}--text text--darken-2`" style="line-height:1.1;">
                            {{ stat.value }}
                          </div>
                          <div class="caption grey--text text--darken-1">{{ stat.label }}</div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <div v-if="chartSummary" class="caption grey--text text-right mt-2">
                    Total {{ chartSummary.total }} chart di entity ini
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card flat>
            <v-card-title class="d-flex align-center">
              <v-icon color="primary" class="mr-2">mdi-content-copy</v-icon>
              <span class="text-subtitle-1 font-weight-medium">Cloning KPI</span>
            </v-card-title>
            <v-card-subtitle class="pb-0">
              Salin seluruh KPI Item dari satu posisi ke posisi lain — bisa lintas entity.
            </v-card-subtitle>
            <v-card-text>
              <v-row align="stretch" class="mt-1">
                <v-col cols="12" md="5">
                  <v-card outlined class="cloning-card cloning-card--source fill-height">
                    <v-card-title class="cloning-card__header cloning-card__header--source">
                      <v-icon left color="white">mdi-file-export-outline</v-icon>
                      Sumber (Copy Dari)
                    </v-card-title>
                    <v-card-text class="pt-4">
                      <v-autocomplete
                        v-model="cloningSourceEntity"
                        :items="entities"
                        item-text="name"
                        item-value="id"
                        label="Entity Sumber"
                        prepend-inner-icon="mdi-domain"
                        no-data-text="Entity tidak ditemukan"
                        outlined
                        dense
                        clearable
                      ></v-autocomplete>
                      <v-autocomplete
                        v-model="cloningSourceChart"
                        :items="cloningSourceCharts"
                        item-text="text"
                        item-value="id"
                        :loading="loadingCloningSourceCharts"
                        :disabled="!cloningSourceEntity"
                        label="Posisi - User"
                        prepend-inner-icon="mdi-account-tie"
                        outlined
                        dense
                        clearable
                        :no-data-text="cloningSourceEntity ? 'Posisi tidak ditemukan' : 'Pilih entity terlebih dahulu'"
                      ></v-autocomplete>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="12" md="2" class="d-flex align-center justify-center">
                  <v-icon size="36" color="primary" class="cloning-arrow">mdi-arrow-right-circle</v-icon>
                </v-col>

                <v-col cols="12" md="5">
                  <v-card outlined class="cloning-card cloning-card--target fill-height">
                    <v-card-title class="cloning-card__header cloning-card__header--target">
                      <v-icon left color="white">mdi-file-import-outline</v-icon>
                      Tujuan (Paste Ke)
                    </v-card-title>
                    <v-card-text class="pt-4">
                      <v-autocomplete
                        v-model="cloningTargetEntity"
                        :items="entities"
                        item-text="name"
                        item-value="id"
                        label="Entity Tujuan"
                        prepend-inner-icon="mdi-domain"
                        no-data-text="Entity tidak ditemukan"
                        outlined
                        dense
                        clearable
                      ></v-autocomplete>
                      <v-autocomplete
                        v-model="cloningTargetChart"
                        :items="cloningTargetCharts"
                        item-text="text"
                        item-value="id"
                        :loading="loadingCloningTargetCharts"
                        :disabled="!cloningTargetEntity"
                        label="Posisi - User"
                        prepend-inner-icon="mdi-account-tie"
                        outlined
                        dense
                        clearable
                        :no-data-text="cloningTargetEntity ? 'Posisi tidak ditemukan' : 'Pilih entity terlebih dahulu'"
                      ></v-autocomplete>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-alert v-if="cloningSameChartError" type="warning" dense outlined class="mt-2">
                Posisi sumber dan tujuan tidak boleh sama.
              </v-alert>

              <v-card outlined class="rounded-lg mt-4 mx-auto" max-width="480px">
                <v-card-text class="d-flex align-center justify-space-between py-3">
                  <div>
                    <div class="font-weight-medium">Sertakan Target &amp; Bobot</div>
                    <div class="caption grey--text">Jika nonaktif, bobot &amp; target hasil clone akan dikosongkan.</div>
                  </div>
                  <v-switch v-model="cloningIncludeTarget" color="success" hide-details></v-switch>
                </v-card-text>
              </v-card>

              <div class="text-center mt-4">
                <v-btn
                  color="primary"
                  large
                  :disabled="!cloningCanSubmit"
                  :loading="cloningProcessing"
                  @click="askConfirmCloning"
                >
                  <v-icon left>mdi-content-copy</v-icon>
                  Proses Cloning KPI
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item>
          <v-card flat>
            <v-card-title class="d-flex align-center py-3">
              <v-icon color="primary" class="mr-2">mdi-history</v-icon>
              <span class="text-subtitle-1 font-weight-medium">Log Aktivitas</span>
              <v-chip
                v-if="entity?.name"
                x-small
                label
                color="blue-grey lighten-5"
                text-color="blue-grey darken-3"
                class="ml-3 font-weight-medium"
              >
                <v-icon left x-small color="blue-grey darken-2">mdi-domain</v-icon>
                {{ entity.name }}
              </v-chip>
              <v-spacer></v-spacer>
              <v-btn icon small @click="fetchActivityLogs(activityLogPage)" :loading="loadingActivityLogs">
                <v-icon small>mdi-refresh</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>

            <div class="activity-log-filters d-flex flex-wrap align-center px-4 py-3">
              <v-text-field
                v-model="activityLogSearch"
                prepend-inner-icon="mdi-magnify"
                label="Cari keterangan"
                outlined
                dense
                hide-details
                clearable
                style="max-width: 240px;"
                @keyup.enter="fetchActivityLogs(1)"
                @click:clear="activityLogSearch = ''; fetchActivityLogs(1)"
              ></v-text-field>
              <v-select
                v-model="activityLogCauserId"
                :items="activityLogCausers"
                item-text="name"
                item-value="id"
                label="User"
                outlined
                dense
                hide-details
                clearable
                style="max-width: 180px;"
                @change="fetchActivityLogs(1)"
              ></v-select>
              <v-select
                v-model="activityLogName"
                :items="activityLogModuleOptions"
                item-text="label"
                item-value="value"
                label="Modul"
                outlined
                dense
                hide-details
                clearable
                style="max-width: 150px;"
                @change="fetchActivityLogs(1)"
              ></v-select>
              <v-select
                v-model="activityLogEvent"
                :items="activityLogEventOptions"
                item-text="label"
                item-value="value"
                label="Event"
                outlined
                dense
                hide-details
                clearable
                style="max-width: 140px;"
                @change="fetchActivityLogs(1)"
              ></v-select>
            </div>
            <v-divider></v-divider>

            <v-data-table
              :headers="activityLogHeaders"
              :items="activityLogs"
              :loading="loadingActivityLogs"
              hide-default-footer
              disable-sort
              class="custom-table"
              no-data-text="Belum ada log aktivitas."
            >
              <template v-slot:[`item.created_at`]="{ item }">
                <div>{{ formatLogDate(item.created_at) }}</div>
                <div class="caption grey--text">{{ formatLogTime(item.created_at) }}</div>
              </template>
              <template v-slot:[`item.causer_name`]="{ item }">
                <div class="d-flex align-center">
                  <v-avatar size="24" color="primary" class="mr-2 flex-shrink-0">
                    <span class="white--text" style="font-size:10px;font-weight:600;">
                      {{ item.causer_name ? item.causer_name.charAt(0).toUpperCase() : '?' }}
                    </span>
                  </v-avatar>
                  <span>{{ item.causer_name || 'System' }}</span>
                </div>
              </template>
              <template v-slot:[`item.event`]="{ item }">
                <v-chip
                  x-small
                  label
                  :color="eventChip(item.event).bg"
                  :text-color="eventChip(item.event).color"
                  class="font-weight-medium"
                >
                  <v-icon left x-small :color="eventChip(item.event).color">{{ eventChip(item.event).icon }}</v-icon>
                  {{ eventChip(item.event).label }}
                </v-chip>
              </template>
              <template v-slot:[`item.log_label`]="{ item }">
                <v-chip x-small outlined color="grey darken-1">{{ item.log_label }}</v-chip>
              </template>
              <template v-slot:[`item.detail`]="{ item }">
                <v-btn
                  v-if="item.has_diff"
                  x-small
                  outlined
                  color="primary"
                  @click="showActivityLogDetail(item)"
                >
                  <v-icon left x-small>mdi-eye-outline</v-icon>
                  Detail
                </v-btn>
                <span v-else class="grey--text">—</span>
              </template>
            </v-data-table>

            <div class="d-flex align-center justify-space-between px-4 py-3 flex-wrap" style="gap:8px;">
              <span class="caption grey--text">
                Total <strong>{{ activityLogTotal }}</strong> log
              </span>
              <v-pagination
                v-model="activityLogPage"
                :length="activityLogLastPage"
                :total-visible="7"
                @input="fetchActivityLogs"
              ></v-pagination>
            </div>
          </v-card>
        </v-tab-item>

      </v-tabs-items>
    </v-card>

    <v-dialog v-model="activityLogDetailDialog" max-width="640px" scrollable>
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-code-braces</v-icon>
          <span class="text-subtitle-1 font-weight-medium">Detail Perubahan Data</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="activityLogDetailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="max-height: 60vh;" class="pt-4">
          <div v-if="loadingActivityLogDetail" class="text-center py-8">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
          <template v-else-if="activityLogDetail">
            <div class="mb-4">
              <div class="text-body-2">{{ activityLogDetail.description }}</div>
              <div class="caption grey--text mt-1">
                {{ activityLogDetail.causer_name }} &middot;
                {{ formatLogDate(activityLogDetail.created_at) }} {{ formatLogTime(activityLogDetail.created_at) }}
              </div>
              <v-chip
                v-if="activityLogDetail.subject_label"
                x-small
                label
                color="blue-grey lighten-5"
                text-color="blue-grey darken-3"
                class="mt-2"
              >
                <v-icon left x-small color="blue-grey darken-2">mdi-tag-outline</v-icon>
                {{ activityLogDetail.subject_label }}
              </v-chip>
            </div>

            <div class="d-flex flex-wrap" style="gap:12px;">
              <template v-if="activityLogDetail.event === 'created'">
                <div
                  v-for="(val, key) in activityLogDetail.attributes"
                  :key="key"
                  class="detail-field detail-field--created"
                >
                  <div class="detail-field__label">{{ key }}</div>
                  <div class="detail-field__value detail-field__value--new">{{ formatDetailValue(val) }}</div>
                </div>
              </template>
              <template v-else-if="activityLogDetail.event === 'deleted'">
                <div
                  v-for="(val, key) in activityLogDetail.old"
                  :key="key"
                  class="detail-field detail-field--deleted"
                >
                  <div class="detail-field__label">{{ key }}</div>
                  <div class="detail-field__value detail-field__value--old">{{ formatDetailValue(val) }}</div>
                </div>
              </template>
              <template v-else>
                <div
                  v-for="key in activityLogDetailKeys"
                  :key="key"
                  class="detail-field"
                  :class="{ 'detail-field--changed': activityLogDetail.old[key] !== activityLogDetail.attributes[key] }"
                >
                  <div class="detail-field__label">{{ key }}</div>
                  <template v-if="activityLogDetail.old[key] !== activityLogDetail.attributes[key]">
                    <div class="detail-field__value detail-field__value--old">{{ formatDetailValue(activityLogDetail.old[key]) }}</div>
                    <div class="detail-field__value detail-field__value--new">{{ formatDetailValue(activityLogDetail.attributes[key]) }}</div>
                  </template>
                  <div v-else class="detail-field__value">{{ formatDetailValue(activityLogDetail.attributes[key]) }}</div>
                </div>
              </template>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

  <v-dialog v-model="entityDialog" max-width="800px" persistent>
    <v-card class="entity-dialog">
      <v-card-title class="dialog-header primary" dark>
        <v-row no-gutters align="center" justify="space-between">
          <div class="d-flex align-center">
            <v-icon large color="white" class="mr-3"> 'mdi-plus-circle' : 'mdi-pencil' </v-icon>
            <span class="white--text text-h5 font-weight-bold">Tambah Entity Baru</span>
          </div>
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>

      <v-card-text class="pt-6">
        <v-stepper v-model="currentStep" class="elevation-0">
          <v-stepper-header class="elevation-0 px-0">
            <v-stepper-step :complete="currentStep > 1" step="1" class="primary--text">
              Informasi Dasar
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="currentStep > 2" step="2">
              Logo & Media
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">
              Review
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="mb-4" outlined>
                <v-card-text>
                  <v-form ref="basicForm" v-model="forms.basic.valid">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.name"
                          label="Nama Entity*"
                          :rules="[v => !!v || 'Nama entity harus diisi']"
                          outlined
                          dense
                          hide-details="auto"
                          class="custom-field"
                          :error-messages="errors.name"
                          @input="errors.name = ''"
                        >
                          <template v-slot:prepend-inner>
                            <v-icon color="primary" small>mdi-domain</v-icon>
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.address"
                          label="Alamat*"
                          :rules="[v => !!v || 'Alamat harus diisi']"
                          outlined
                          dense
                          hide-details="auto"
                          class="custom-field"
                          :error-messages="errors.address"
                          @input="errors.address = ''"
                        >
                          <template v-slot:prepend-inner>
                            <v-icon color="primary" small>mdi-map-marker</v-icon>
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.phone"
                          label="Nomor Telepon*"
                          :rules="[
                            v => !!v || 'Nomor telepon harus diisi',
                            v => /^\d+$/.test(v) || 'Nomor telepon harus berupa angka'
                          ]"
                          outlined
                          dense
                          hide-details="auto"
                          class="custom-field"
                          :error-messages="errors.phone"
                          @input="errors.phone = ''"
                        >
                          <template v-slot:prepend-inner>
                            <v-icon color="primary" small>mdi-phone</v-icon>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>

              <div class="d-flex justify-end">
                <v-btn
                  color="primary"
                  :disabled="!forms.basic.valid"
                  @click="currentStep = 2"
                >
                  Lanjut
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </div>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card class="mb-4" outlined>
                <v-card-text>
                  <v-row align="center" justify="center">
                    <v-col cols="12" class="text-center">
                      <v-avatar
                        size="150"
                        class="mb-4"
                        v-if="logoPreview || editedItem.currentLogo"
                      >
                        <v-img
                          :src="logoPreview || editedItem.currentLogo"
                          contain
                        ></v-img>
                      </v-avatar>

                      <v-file-input
                        v-model="editedItem.logo"
                        accept="image/*"
                        label="Upload Logo"
                        prepend-icon=""
                        prepend-inner-icon="mdi-camera"
                        show-size
                        :rules="[
                          v => !v || v.size < 2000000 || 'Ukuran logo harus kurang dari 2MB'
                        ]"
                        outlined
                        dense
                        class="custom-field"
                        @change="previewLogo"
                      >
                        <template v-slot:selection="{ text }">
                          <v-chip
                            small
                            label
                            color="primary"
                          >
                            {{ text }}
                          </v-chip>
                        </template>
                      </v-file-input>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <div class="d-flex justify-space-between">
                <v-btn text @click="currentStep = 1">
                  <v-icon left>mdi-arrow-left</v-icon>
                  Kembali
                </v-btn>
                <v-btn color="primary" @click="currentStep = 3">
                  Lanjut
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </div>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-card class="mb-4" outlined>
                <v-card-text>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="text-caption">Nama Entity</v-list-item-subtitle>
                        <v-list-item-title>{{ editedItem.name }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="text-caption">Alamat</v-list-item-subtitle>
                        <v-list-item-title>{{ editedItem.address }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="text-caption">Nomor Telepon</v-list-item-subtitle>
                        <v-list-item-title>{{ editedItem.phone }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item v-if="logoPreview || editedItem.currentLogo">
                      <v-list-item-content>
                        <v-list-item-subtitle class="text-caption">Logo</v-list-item-subtitle>
                        <v-list-item-title>
                          <v-avatar size="64">
                            <v-img :src="logoPreview || editedItem.currentLogo" contain></v-img>
                          </v-avatar>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>

              <div class="d-flex justify-space-between">
                <v-btn text @click="currentStep = 2">
                  <v-icon left>mdi-arrow-left</v-icon>
                  Kembali
                </v-btn>
                <v-btn
                  color="success"
                  :loading="loading"
                  @click="submitEntity"
                >
                Submit
                </v-btn>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-dialog v-model="EditDialog" max-width="600px" persistent>
    <v-card>
      <v-card-title class="primary white--text">
        <span class="text-h6">Edit Entity</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeEdit">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-4">
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.name"
                label="Nama Entity"
                prepend-inner-icon="mdi-domain"
                :rules="[v => !!v || 'Username harus diisi']"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.address"
                label="Email"
                prepend-inner-icon="mdi-map-marker"
                :rules="[v => !!v || 'alamat harus diisi']"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.phone"
                label="Phone"
                prepend-inner-icon="mdi-phone"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-file-input
                v-model="editedItem.logo"
                label="Logo Company"
                prepend-inner-icon="mdi-camera"
                accept="image/*"
                outlined
                dense
              ></v-file-input>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="pb-4 px-6">
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="closeEdit">Cancel</v-btn>
        <v-btn color="success" @click="EditSubmit">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
 
  <v-dialog v-model="deleteDialog" max-width="400px">
        <v-card>
          <v-card-title class="headline error--text">
            <v-icon left color="error">mdi-alert-circle</v-icon>
            Confirm Delete
          </v-card-title>
          <v-card-text class="pa-4">
            Are you sure you want to delete this Entity? This action cannot be undone.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteDialog = false">
              Cancel
            </v-btn>
            <v-btn color="error" @click="confirmDelete">
              <v-icon left>mdi-delete</v-icon>
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
  </v-dialog>
 
  <v-dialog v-model="menuDialog" max-width="520px" persistent>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon color="white" class="mr-3">{{ menuFormMode === 'edit' ? 'mdi-pencil' : 'mdi-plus-circle' }}</v-icon>
        <span class="text-h6">{{ menuFormMode === 'edit' ? 'Edit Menu' : 'Tambah Menu' }}</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeMenuDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-form ref="menuFormRef" v-model="menuFormValid">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="menuForm.name"
                label="Nama Menu"
                prepend-inner-icon="mdi-tag-text-outline"
                :rules="[v => !!v || 'Nama menu harus diisi']"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="menuForm.route"
                label="Route"
                prepend-inner-icon="mdi-link-variant"
                hint="Contoh: /input — kosongkan jika menu ini hanya grup (punya sub-menu)"
                persistent-hint
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="menuForm.parent_id"
                :items="parentMenuOptions"
                item-text="name"
                item-value="id"
                label="Parent Menu"
                prepend-inner-icon="mdi-file-tree-outline"
                hint="Kosongkan untuk menu level atas (top level)"
                persistent-hint
                outlined
                dense
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" class="d-flex align-center" style="gap:12px;">
              <div class="icon-preview-box d-flex align-center rounded-lg pa-2">
                <v-icon color="primary" size="26" class="mr-2">mdi-{{ menuForm.icon || 'help-circle-outline' }}</v-icon>
                <span class="grey--text text-caption">{{ menuForm.icon ? ('mdi-' + menuForm.icon) : 'Belum dipilih' }}</span>
              </div>
              <v-btn outlined color="primary" small @click="openIconPicker">
                <v-icon left small>mdi-shape-outline</v-icon> Pilih Icon
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-switch v-model="menuForm.is_active" label="Aktif" color="success" hide-details></v-switch>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions class="pb-4 px-6">
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="closeMenuDialog">Batal</v-btn>
        <v-btn color="success" :loading="savingMenu" @click="saveMenu">Simpan</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="menuDeleteDialog" max-width="400px">
    <v-card>
      <v-card-title class="headline error--text">
        <v-icon left color="error">mdi-alert-circle</v-icon>
        Hapus Menu
      </v-card-title>
      <v-card-text class="pa-4">
        Yakin ingin menghapus menu <strong>{{ menuToDelete ? menuToDelete.name : '' }}</strong>?
        <span v-if="menuToDelete && menuToDelete.children && menuToDelete.children.length">
          Semua sub-menu di dalamnya akan ikut terhapus.
        </span>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="menuDeleteDialog = false">Batal</v-btn>
        <v-btn color="error" :loading="deletingMenu" @click="confirmDeleteMenu">
          <v-icon left>mdi-delete</v-icon> Hapus
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="iconPickerDialog" max-width="640px">
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon color="white" class="mr-3">mdi-shape-outline</v-icon>
        <span class="text-h6">Pilih Icon</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="iconPickerDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-text-field
          v-model="iconSearch"
          prepend-inner-icon="mdi-magnify"
          label="Cari icon (mis. account, chart, home)"
          outlined
          dense
          clearable
          autofocus
        ></v-text-field>
        <div v-if="mdiIconsLoading" class="text-center py-10">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <div class="grey--text caption mt-2">Memuat daftar icon…</div>
        </div>
        <template v-else>
          <div class="icon-picker-grid">
            <v-tooltip v-for="icon in visibleMdiIcons" :key="icon.name" top>
              <template v-slot:activator="{ on, attrs }">
                <button
                  type="button"
                  class="icon-picker-item"
                  :class="{ 'icon-picker-item--selected': menuForm.icon === icon.name }"
                  v-bind="attrs"
                  v-on="on"
                  @click="selectIcon(icon.name)"
                >
                  <v-icon>mdi-{{ icon.name }}</v-icon>
                </button>
              </template>
              <span>{{ icon.name }}</span>
            </v-tooltip>
            <div v-if="!filteredMdiIcons.length" class="grey--text text-caption pa-4 text-center" style="width:100%;">
              Tidak ada icon yang cocok.
            </div>
          </div>
          <div class="d-flex align-center justify-space-between mt-2">
            <v-btn
              v-if="visibleMdiIcons.length < filteredMdiIcons.length"
              text small color="primary"
              @click="iconDisplayLimit += 150"
            >
              <v-icon left small>mdi-chevron-down</v-icon>
              Tampilkan lebih banyak
            </v-btn>
            <span v-else></span>
            <span class="grey--text text-caption">
              Menampilkan {{ visibleMdiIcons.length }} dari {{ filteredMdiIcons.length }} icon
            </span>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-dialog v-model="DialogPeriode" max-width="700px" persistent>
    <v-card>
      <v-card-title class="cyan darken-5 white--text">
        <v-icon large color="white" class="mr-3">mdi-cog</v-icon>
        <span class="text-h6">Ubah Pengaturan Periode Input</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closePeriodeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

        <v-card-text class="pa-6">
          <v-form ref="periodForm" v-model="periodFormValid">
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="start_date"
                  :items="dayOptions"
                  label="Tanggal Mulai Input"
                  hint="Tanggal awal (1-31) setiap bulan saat pengisian KPI dibuka"
                  persistent-hint
                  outlined
                  dense
                  class="rounded-lg"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="end_date"
                  :items="dayOptions"
                  :rules="[v => v >= start_date || 'Harus ≥ Tanggal Mulai']"
                  label="Tanggal Akhir Input"
                  hint="Tanggal batas (1-31) setiap bulan saat pengisian KPI ditutup"
                  persistent-hint
                  outlined
                  dense
                  class="rounded-lg"
                />
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="input_month"
                  :items="monthOptions"
                  label="Bulan Aktif Input"
                  hint="Pilih 'Auto' agar bulan aktif input dinamis, selalu mengikuti waktu sekarang (1 bulan sebelum bulan berjalan — mis. sekarang Juni → yang aktif diisi Mei). Atau kunci ke satu bulan tertentu."
                  persistent-hint
                  outlined
                  dense
                  class="rounded-lg"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

      <v-card-actions class="pb-4 px-6">
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="closePeriodeDialog">Batal</v-btn>
        <v-btn color="cyan text-white" :disabled="end_date < start_date" @click="SaveSetting">Simpan</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="accountingBulkDialog" max-width="600px">
    <v-card>
      <v-card-title class="orange darken-2 white--text">
        <v-icon left dark>mdi-calculator-variant</v-icon>
        <span class="text-h6">Konfirmasi Adjust Accounting</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="accountingBulkDialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-6">
        <div v-if="!eligibleCharts.length" class="text-center grey--text py-4">
          <v-icon size="48" color="grey lighten-1">mdi-information-outline</v-icon>
          <div class="mt-2">Tidak ada chart Published dengan KPI accounting top-level di entity aktif.</div>
        </div>
        <template v-else>
          <div class="mb-3">
            <strong>{{ eligibleCharts.length }} chart</strong> berikut akan dipindah ke status
            <strong>Adjust Accounting</strong>:
          </div>
          <div class="eligible-table-wrap rounded-lg">
            <v-simple-table dense class="eligible-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width:40px;">No</th>
                    <th>Jabatan</th>
                    <th>Nama User</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(c, i) in eligibleCharts" :key="c.id">
                    <td class="grey--text">{{ i + 1 }}</td>
                    <td class="font-weight-medium">{{ c.position_name }}</td>
                    <td :class="{ 'grey--text font-italic': !c.user_name }">{{ c.user_name || 'Posisi kosong' }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
        </template>
      </v-card-text>
      <v-card-actions class="pb-4 px-6">
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="accountingBulkDialog = false">Batal</v-btn>
        <v-btn
          v-if="eligibleCharts.length"
          color="orange darken-2"
          dark
          :loading="applyingBulk"
          @click="confirmAccountingBulk"
        >
          Ubah {{ eligibleCharts.length }} Chart
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="cloningConfirmDialog" max-width="440px">
    <v-card>
      <v-card-title class="headline warning--text">
        <v-icon left color="warning">mdi-alert-circle-outline</v-icon>
        Konfirmasi Cloning
      </v-card-title>
      <v-card-text class="pa-4">
        Yakin ingin meng-clone KPI item dari posisi sumber ke posisi tujuan?
        <div class="mt-3 d-flex align-center" v-if="cloningIncludeTarget">
          <v-icon small color="info" class="mr-2">mdi-information-outline</v-icon>
          <span>Target &amp; bobot akan ikut disalin.</span>
        </div>
        <div class="mt-3 d-flex align-center" v-else>
          <v-icon small color="warning" class="mr-2">mdi-alert</v-icon>
          <span>Target &amp; bobot akan <strong>dikosongkan (reset)</strong> pada hasil clone.</span>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn text @click="cloningConfirmDialog = false">Batal</v-btn>
        <v-btn color="primary" :loading="cloningProcessing" @click="confirmCloning">
          <v-icon left>mdi-check</v-icon> Ya, Proses
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  </v-container>
</template>

<script>
// Urutan harus sama persis dengan urutan <v-tab> di template.
const TAB_SLUGS = ['entity', 'role', 'menu', 'config', 'cloning-kpi', 'activity-log'];

export default {
  name: 'SuperSetup',
  data() {
    return {
      activeTab: 0,
      search: '',
      loading: false,
      roleOptions: ['super_admin', 'admin', 'user'],
      roleSearch: '',
      statistics: {
        totalMenus: 25,
        totalRoles: 8,
        totalEntities: 15
      },
      // ── Menu tab (tree + drag-drop) ──
      menuTree: [],
      loadingMenus: false,
      menuSearch: '',
      menuDialog: false,
      menuFormMode: 'create',
      menuFormValid: true,
      menuForm: { id: null, name: '', route: '', parent_id: null, icon: '', is_active: true },
      savingMenu: false,
      menuDeleteDialog: false,
      menuToDelete: null,
      deletingMenu: false,
      dragState: null,
      savingOrder: false,
      // ── Role tab (permission matrix) ──
      togglingKey: null,
      // ── Icon picker ──
      iconPickerDialog: false,
      iconSearch: '',
      iconDisplayLimit: 150,
      mdiIconList: [],
      mdiIconsLoading: false,
      // ── Cloning KPI tab ──
      cloningSourceEntity: null,
      cloningTargetEntity: null,
      cloningSourceChart: null,
      cloningTargetChart: null,
      cloningSourceCharts: [],
      cloningTargetCharts: [],
      loadingCloningSourceCharts: false,
      loadingCloningTargetCharts: false,
      cloningIncludeTarget: true,
      cloningProcessing: false,
      cloningConfirmDialog: false,
      // ── Log Aktivitas tab ──
      activityLogs: [],
      loadingActivityLogs: false,
      activityLogSearch: '',
      activityLogEvent: null,
      activityLogName: null,
      activityLogCauserId: null,
      activityLogCausers: [],
      activityLogPage: 1,
      activityLogLastPage: 1,
      activityLogTotal: 0,
      activityLogEventOptions: [
        { label: 'Created', value: 'created' },
        { label: 'Updated', value: 'updated' },
        { label: 'Deleted', value: 'deleted' },
        { label: 'Login', value: 'login' },
        { label: 'Logout', value: 'logout' },
        { label: 'Import', value: 'batch_import' },
      ],
      // ponytail: mirror App\Http\Controllers\Pawon\PawonActivityController::LOG_LABELS
      activityLogModuleOptions: [
        { label: 'Auth', value: 'auth' },
        { label: 'Chart', value: 'chart' },
        { label: 'Chart History', value: 'chart_user_history' },
        { label: 'Entity', value: 'entity' },
        { label: 'KPI Item', value: 'kpi_item' },
        { label: 'KPI Share', value: 'kpi_item_share' },
        { label: 'KPI Period', value: 'kpi_period' },
        { label: 'KPI Score', value: 'kpi_score' },
        { label: 'KPI Status', value: 'kpi_status' },
        { label: 'Struktur', value: 'structure_chart' },
        { label: 'User', value: 'user' },
        { label: 'User Mgmt', value: 'user_management' },
      ],
      activityLogDetailDialog: false,
      loadingActivityLogDetail: false,
      activityLogDetail: null,
      activityLogHeaders: [
        { text: 'Waktu', value: 'created_at', width: '13%' },
        { text: 'User', value: 'causer_name', width: '18%' },
        { text: 'Event', value: 'event', width: '10%' },
        { text: 'Modul', value: 'log_label', width: '12%' },
        { text: 'Keterangan', value: 'description' },
        { text: '', value: 'detail', sortable: false, width: '90px' },
      ],
      snackbar:{
          color: null,
          icon: null,
          mode: null,
          position: "top",
          text: null,
          timeout: 7500,
          title: null,
          visible: false
      },
      entityDialog: false,
      EditDialog:false,
      deleteDialog:false,
      closeDialogedit:false,
      DialogPeriode:false,
      periodFormValid: true,
      accountingBulkDialog: false,
      loadingEligible: false,
      applyingBulk: false,
      loadingSummary: false,
      eligibleCharts: [],
      chartSummary: null,
      selectedEntity:'',
      start_date: 1,
      end_date: 31,
      input_month: 0,
      valid: true,
      editedIndex: -1,
      editedItem: {
        name: '',
        address: '',
        phone: '',
        logo: null,
        currentLogo: null
      },
      defaultItem: {
        name: '',
        address: '',
        phone: '',
        logo: null,
        currentLogo: null
      },
      currentStep: 1,
      logoPreview: null,
      forms: {
        basic: { valid: true }
      },
      errors: {
        name: '',
        address: '',
        phone: ''
      },
      entityHeaders: [
        { text: 'Logo', value: 'logo' },
        { text: 'Nama Entity', value: 'name', width: '20%' },
        { text: 'Address', value: 'address', width: '15%' },
        { text: 'Phone', value: 'phone' },
        { text: 'Created_at', value: 'created_at' },
        { text: 'Action', value: 'actions', sortable: false, width: '100px' }
      ],
      entities: [],
      menu_roles: [],
      entitySettings: null,

    }
  },
  computed: {

  entity() {
      return this.$store.state.entity;
    },

  baseURL() {
      return process.env.VUE_APP_URL;
    },

  entityToDisplay() {
    if (this.selectedEntity) {
      return this.entities.find(e => e.id === this.selectedEntity) || {};
    }
    return this.entity;
    },

  dayOptions() {
    return Array.from({ length: 31 }, (_, i) => i + 1);
  },

  monthOptions() {
    // value 0 = "Auto" -> ikut bulan berjalan (lihat KpiInputController: bulan = sekarang - 1).
    const names = ['Auto (Bulan)', 'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
      'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
    return names.map((text, value) => ({ text, value }));
  },

  settingCards() {
    const s = this.entitySettings;
    const monthName = (v) => {
      // Auto -> tampilkan bulan yang beneran aktif sekarang (bukan cuma teks "Auto"),
      // sesuai logika KpiInputController: bulan aktif = bulan berjalan - 1.
      if (Number(v) === 0) {
        const now = new Date();
        const autoDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        return `Auto (${this.monthOptions[autoDate.getMonth() + 1].text})`;
      }
      const found = this.monthOptions.find(m => m.value === Number(v));
      return found ? found.text : '-';
    };
    return [
      { key: 'start_date', icon: 'mdi-calendar-start', label: 'Tanggal Mulai Input', display: s ? `Tanggal ${s.start_date}` : '-' },
      { key: 'end_date', icon: 'mdi-calendar-end', label: 'Tanggal Akhir Input', display: s ? `Tanggal ${s.end_date}` : '-' },
      { key: 'input_month', icon: 'mdi-calendar-month', label: 'Bulan Aktif Input', display: s ? monthName(s.input_month) : '-' },
    ];
  },

  chartStatusStats() {
    const counts = (this.chartSummary && this.chartSummary.counts) || {};
    return [
      { key: 'published', label: 'Published', icon: 'mdi-check-circle', base: 'green', value: counts.published || 0 },
      { key: 'unpublished', label: 'Unpublished', icon: 'mdi-circle-outline', base: 'blue-grey', value: counts.unpublished || 0 },
      { key: 'adjust_accounting', label: 'Adjust Accounting', icon: 'mdi-calculator-variant', base: 'orange', value: counts.adjust_accounting || 0 },
    ];
  },

  // Pilihan Parent Menu di form Menu: hanya menu top-level, kecuali dirinya sendiri.
  parentMenuOptions() {
    return this.menuTree
      .filter(m => m.id !== this.menuForm.id)
      .map(m => ({ id: m.id, name: m.name }));
  },

  filteredMdiIcons() {
    const term = (this.iconSearch || '').trim().toLowerCase();
    return term ? this.mdiIconList.filter(i => i.search.includes(term)) : this.mdiIconList;
  },

  visibleMdiIcons() {
    return this.filteredMdiIcons.slice(0, this.iconDisplayLimit);
  },

  cloningSameChartError() {
    return !!this.cloningSourceChart && !!this.cloningTargetChart && this.cloningSourceChart === this.cloningTargetChart;
  },

  cloningCanSubmit() {
    return !!this.cloningSourceChart && !!this.cloningTargetChart && !this.cloningSameChartError;
  },

  activityLogDetailKeys() {
    if (!this.activityLogDetail) return [];
    return [...new Set([
      ...Object.keys(this.activityLogDetail.old || {}),
      ...Object.keys(this.activityLogDetail.attributes || {}),
    ])];
  },
    },
  created() {
      // Balikin tab aktif dari URL (?tab=...) biar refresh tidak selalu ke tab pertama.
      const fromQuery = TAB_SLUGS.indexOf(this.$route.query.tab);
      if (fromQuery !== -1) this.activeTab = fromQuery;
    },

  mounted(){
      this.getEntity()
      this.getMenuRole()
      this.getMenus()
      this.getEntitySettings()
      this.getChartSummary()
      if (TAB_SLUGS[this.activeTab] === 'activity-log') {
        this.fetchActivityLogs(1)
        this.fetchActivityLogCausers()
      }

      // Entity dipindah lewat selector di navbar atas (NavigationHeaderDefault.vue) ->
      // reload halaman ini biar semua data (summary, dialog eligible, dst) fresh untuk
      // entity yang baru dipilih.
      this.$root.$off('entity-updated');
      this.$root.$on('entity-updated', () => window.location.reload());
    },

  watch: {
    activeTab(val) {
      const tab = TAB_SLUGS[val];
      if (tab && this.$route.query.tab !== tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } }).catch(() => {});
      }
      if (tab === 'activity-log' && !this.activityLogs.length) {
        this.fetchActivityLogs(1);
        this.fetchActivityLogCausers();
      }
    },
    iconSearch() {
      this.iconDisplayLimit = 150;
    },
    cloningSourceEntity(val) {
      this.loadCloningCharts(val, 'source');
    },
    cloningTargetEntity(val) {
      this.loadCloningCharts(val, 'target');
    },
  },

  methods: {

  async fetchActivityLogs(page = 1) {
    this.loadingActivityLogs = true;
    this.activityLogPage = page;
    try {
      const res = await this.$axios.get(`${process.env.VUE_APP_URL}/api/activity-logs`, {
        headers: { Authorization: `Bearer ${this.$store.getters.isTokenUser}` },
        params: {
          page,
          search: this.activityLogSearch || undefined,
          event: this.activityLogEvent || undefined,
          log_name: this.activityLogName || undefined,
          causer_id: this.activityLogCauserId || undefined,
          entity_id: this.entity?.id,
        },
      });
      this.activityLogs = res.data.data;
      this.activityLogTotal = res.data.total;
      this.activityLogLastPage = res.data.last_page;
    } catch (err) {
      this.snackbar = {
        color: 'error',
        icon: 'mdi-alert-circle',
        mode: 'multi-line',
        position: 'top',
        timeout: 5000,
        title: 'Error',
        text: err.response?.data?.message || 'Gagal memuat log aktivitas.',
        visible: true,
      };
    } finally {
      this.loadingActivityLogs = false;
    }
  },

  async fetchActivityLogCausers() {
    try {
      const res = await this.$axios.get(`${process.env.VUE_APP_URL}/api/activity-logs/causers`, {
        headers: { Authorization: `Bearer ${this.$store.getters.isTokenUser}` },
        params: { entity_id: this.entity?.id },
      });
      this.activityLogCausers = res.data;
    } catch (err) {
      // dropdown filter opsional, gagal diam-diam saja
    }
  },

  async showActivityLogDetail(item) {
    this.activityLogDetailDialog = true;
    this.loadingActivityLogDetail = true;
    this.activityLogDetail = null;
    try {
      const res = await this.$axios.get(`${process.env.VUE_APP_URL}/api/activity-logs/${item.id}`, {
        headers: { Authorization: `Bearer ${this.$store.getters.isTokenUser}` },
        params: { entity_id: this.entity?.id },
      });
      this.activityLogDetail = res.data;
    } catch (err) {
      this.snackbar = {
        color: 'error',
        icon: 'mdi-alert-circle',
        mode: 'multi-line',
        position: 'top',
        timeout: 5000,
        title: 'Error',
        text: err.response?.data?.message || 'Gagal memuat detail log.',
        visible: true,
      };
      this.activityLogDetailDialog = false;
    } finally {
      this.loadingActivityLogDetail = false;
    }
  },

  formatDetailValue(val) {
    if (val === null || val === undefined || val === '') return '(kosong)';
    if (typeof val === 'object') return JSON.stringify(val);
    return String(val);
  },

  eventChip(event) {
    const map = {
      created:      { color: '#16A34A', bg: 'green lighten-5',  icon: 'mdi-plus-circle',        label: 'Created' },
      updated:      { color: '#D97706', bg: 'orange lighten-5', icon: 'mdi-pencil',              label: 'Updated' },
      deleted:      { color: '#DC2626', bg: 'red lighten-5',    icon: 'mdi-delete',              label: 'Deleted' },
      restored:     { color: '#7C3AED', bg: 'purple lighten-5', icon: 'mdi-restore',             label: 'Restored' },
      login:        { color: '#0891B2', bg: 'cyan lighten-5',   icon: 'mdi-login',               label: 'Login' },
      logout:       { color: '#64748B', bg: 'grey lighten-3',   icon: 'mdi-logout',               label: 'Logout' },
      batch_import: { color: '#0891B2', bg: 'cyan lighten-5',   icon: 'mdi-file-import',          label: 'Import' },
    };
    return map[event] || { color: '#64748B', bg: 'grey lighten-3', icon: 'mdi-circle-small', label: event };
  },

  formatLogDate(value) {
    return new Date(value).toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' });
  },

  formatLogTime(value) {
    return new Date(value).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  },

  getLogoUrl(filename) {
    

     return `${process.env.VUE_APP_URL}/storage/${filename}`;
    },

  handleSearch() {
      
    },

  getEntityTypeColor(type) {
      const colors = {
        Core: 'primary',
        Business: 'success',
        Transaction: 'warning'
      }
      return colors[type] || 'grey'
    },

  openDialog() {
      this.entityDialog = true
    },

  closeDialog() {
      this.entityDialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        if (this.$refs.entityForm) {
          this.$refs.entityForm.reset()
        }
      })
    },

  previewLogo(file) {
      if (file) {
        this.logoPreview = URL.createObjectURL(file)
      } else {
        this.logoPreview = null
      }
    },

  closeEdit() {
      this.EditDialog = false
    },

  Edit(editedItem) {
      this.EditDialog = true
      this.loading = true
      this.editedItem.id = editedItem.id;
      this.editedItem.name = editedItem.name
      this.editedItem.address = editedItem.address
      this.editedItem.phone = editedItem.phone
      this.editedItem.logo = editedItem.null
    },

  async EditSubmit() {
      this.$store.dispatch('setOverlay', true);
      await new Promise(resolve => setTimeout(resolve, 300));

      const formData = new FormData();
      formData.append('name', this.editedItem.name);
      formData.append('address', this.editedItem.address);
      formData.append('phone', this.editedItem.phone);

      if (this.editedItem.logo instanceof File) {
        formData.append('logo', this.editedItem.logo);
      }

      try {
        console.log("Submit edit for entity id:", this.editedItem.id); 
        const res = await this.$axios.post(
          `${process.env.VUE_APP_URL}/api/entities/${this.editedItem.id}`, 
          formData,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        console.log(res.data);
        this.$store.dispatch('setOverlay', false);
        this.EditDialog = false;
        await this.getEntity();

        this.snackbar = {
          color: "success",
          icon: "mdi-check-circle",
          mode: "multi-line",
          position: "top",
          timeout: 7500,
          title: "Success",
          text: "Successfully Edit Entity",
          visible: true
        };
      } catch (err) {
        this.$store.dispatch('setOverlay', false);
        this.snackbar = {
          color: "error",
          icon: "mdi-alert-circle",
          mode: "multi-line",
          position: "top",
          timeout: 7500,
          title: "Error",
          text: err.response?.data?.message || 'Failed to update entity',
          visible: true
        };
      }
    },
  
  async getEntity(){
      this.loading = true
      await this.$axios.get(`${process.env.VUE_APP_URL}/api/entities`, { 
          headers: { Authorization: `Bearer ${this.$store.getters.isTokenUser}` } 
      })
      .then(res => {
        
          this.loading = false
          this.entities = res.data
        
      })
    },

  async submitEntity() {
        this.$store.dispatch('setOverlay', true)
        await new Promise(resolve => setTimeout(resolve, 500));
        const formData = new FormData();
        formData.append('name', this.editedItem.name);
        formData.append('address', this.editedItem.address);
        formData.append('phone', this.editedItem.phone);

        if (this.editedItem.logo) {
          formData.append('logo', this.editedItem.logo); 
        }

        try {
          const res = await this.$axios.post(`${process.env.VUE_APP_URL}/api/entities`, formData, {
            headers: {
              Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
              'Content-Type': 'multipart/form-data'
            }
          });
          localStorage.setItem('entity', JSON.stringify(this.selected));
          this.$store.dispatch('setOverlay', false)
          this.entityDialog = false
          await this.getEntity();
          console.log(res.data);
          this.snackbar = {
            color: "success",
            icon: "mdi-checkbox-marked-circle",
            mode: "multi-line",
            position: "top",
            timeout: 7500,
            title: "Success",
            text: "Successfully Add Entity",
            visible: true
          };
          window.location.reload();
        } catch (err) {
          this.$store.dispatch('setOverlay', false);
          this.snackbar = {
            color: "error",
            icon: "mdi-alert-circle",
            mode: "multi-line",
            position: "top",
            timeout: 7500,
            title: "Error",
            text: err.response?.data?.message || 'Error upload logo',
            visible: true
          };
        }
    },

  async getEntitySettings(){
      if (!this.entity || !this.entity.id) return;
      const res = await this.$axios.get(
        `${process.env.VUE_APP_URL}/api/entities/${this.entity.id}`,
        { headers: { Authorization: `Bearer ${this.$store.getters.isTokenUser}` } }
      );
      this.entitySettings = {
        input_month: Number(res.data.input_month) || 0,
        start_date: Number(res.data.start_date) || 1,
        end_date: Number(res.data.end_date) || 10,
      };
    },

  async getChartSummary() {
      this.loadingSummary = true;
      try {
        const res = await this.$axios.get(
          `${process.env.VUE_APP_URL}/api/charts/status-summary`,
          { headers: { Authorization: `Bearer ${this.$store.getters.isTokenUser}` } }
        );
        this.chartSummary = res.data;
      } catch (err) {
        this.chartSummary = null;
      } finally {
        this.loadingSummary = false;
      }
    },

  async SaveSetting(){
    this.$store.dispatch('setOverlay', true)
    await new Promise(resolve => setTimeout(resolve, 500));
    const payload = {
      start_date: this.start_date,
      end_date: this.end_date,
      input_month: this.input_month,
    }
    try {
    await this.$axios.post(
        `${process.env.VUE_APP_URL}/api/entities/${this.entity.id}`,payload,{headers: {Authorization: `Bearer ${this.$store.getters.isTokenUser}`}}
      );
      this.$store.dispatch('setOverlay', false)
      this.DialogPeriode = false
      await this.getEntitySettings();
      this.snackbar = {
        color: "success",
        icon: "mdi-checkbox-marked-circle",
        mode: "multi-line",
        position: "top",
        timeout: 7500,
        title: "Success",
        text: "Successfully Save Setting",
        visible: true
      };
    } catch (error) {
       console.error('Gagal menyimpan:', error);
    }finally{
       this.$store.dispatch('setOverlay', false)
    }
  },

  deleteItem(item) {
      console.log('ini delete',item)
      this.itemId = item.id;
      this.deleteDialog = true
    },

  async confirmDelete() {
      try {
        const res = await this.$axios.delete(
          `${process.env.VUE_APP_URL}/api/entities/${this.itemId}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.isTokenUser}`
            }
          }
        );
        this.deleteDialog = false;
        await this.getEntity(); 
        this.snackbar = {
          color: "success",
          icon: "mdi-check",
          title: "Deleted",
          text: res.data.status === "deleted" ? "Entity successfully deleted." : "Entity deleted.",
          visible: true,
          position: "top"
          };
          window.location.reload();
          } catch (err) {
            console.error('Delete error:', err);
            this.snackbar = {
              color: "error",
              icon: "mdi-alert",
              title: "Error",
              text: "Delete failed.",
              visible: true
            };
          }
    },

  openPeriodeDialog(){
      // Prefill dengan nilai entity yang sudah tersimpan, biar dialog tidak muncul kosong.
      const s = this.entitySettings;
      this.start_date = s ? s.start_date : 1;
      this.end_date = s ? s.end_date : 31;
      this.input_month = s ? s.input_month : 0;
      this.DialogPeriode = true
    },

  closePeriodeDialog(){
      this.DialogPeriode = false
    },

  async openAccountingBulkDialog() {
      this.loadingEligible = true;
      try {
        const res = await this.$axios.get(
          `${process.env.VUE_APP_URL}/api/charts/accounting-eligible`,
          { headers: { Authorization: `Bearer ${this.$store.getters.isTokenUser}` } }
        );
        this.eligibleCharts = res.data.charts || [];
        this.accountingBulkDialog = true;
      } catch (err) {
        this.snackbar = {
          color: "error",
          icon: "mdi-alert",
          title: "Error",
          text: err.response?.data?.message || "Gagal memuat daftar chart eligible.",
          visible: true,
        };
      } finally {
        this.loadingEligible = false;
      }
    },

  async confirmAccountingBulk() {
      this.applyingBulk = true;
      try {
        const res = await this.$axios.post(
          `${process.env.VUE_APP_URL}/api/charts/bulk-adjust-accounting`,
          {},
          { headers: { Authorization: `Bearer ${this.$store.getters.isTokenUser}` } }
        );
        this.accountingBulkDialog = false;
        this.snackbar = {
          color: "success",
          icon: "mdi-checkbox-marked-circle",
          title: "Berhasil",
          text: res.data.message,
          visible: true,
        };
        this.getChartSummary();
      } catch (err) {
        this.snackbar = {
          color: "error",
          icon: "mdi-alert",
          title: "Error",
          text: err.response?.data?.message || "Gagal mengubah status chart.",
          visible: true,
        };
      } finally {
        this.applyingBulk = false;
      }
    },

  async getMenuRole(){
      this.loading = true
      await this.$axios.get(`${process.env.VUE_APP_URL}/api/menu-roles`, {
          headers: { Authorization: `Bearer ${this.$store.getters.isTokenUser}` }
      })
      .then(res => {

        this.loading = false
        this.menu_roles = res.data.menu_roles;

      })
    },

  // ═══════════════════════════════════════════════════════════════
  // MENU TAB — CRUD + drag-and-drop reorder
  // ═══════════════════════════════════════════════════════════════

  async getMenus() {
      this.loadingMenus = true;
      try {
        const res = await this.$axios.get(`${process.env.VUE_APP_URL}/api/menus`, {
          headers: { Authorization: `Bearer ${this.$store.getters.isTokenUser}` },
        });
        this.menuTree = res.data.menus || [];
      } catch (err) {
        console.error('Gagal memuat menu:', err);
      } finally {
        this.loadingMenus = false;
      }
    },

  matchesSearch(item, term) {
      const t = (term || '').trim().toLowerCase();
      if (!t) return true;
      const self = (item.name || '').toLowerCase().includes(t) || (item.route || '').toLowerCase().includes(t);
      if (self) return true;
      return (item.children || []).some(child => this.matchesSearch(child, term));
    },

  openAddMenu(parentMenu) {
      this.menuFormMode = 'create';
      this.menuForm = {
        id: null,
        name: '',
        route: '',
        parent_id: parentMenu ? parentMenu.id : null,
        icon: '',
        is_active: true,
      };
      this.menuDialog = true;
    },

  openEditMenu(menu) {
      this.menuFormMode = 'edit';
      this.menuForm = {
        id: menu.id,
        name: menu.name,
        route: menu.route || '',
        parent_id: menu.parent_id || null,
        icon: menu.icon || '',
        is_active: !!menu.is_active,
      };
      this.menuDialog = true;
    },

  closeMenuDialog() {
      this.menuDialog = false;
    },

  async saveMenu() {
      if (this.$refs.menuFormRef && !this.$refs.menuFormRef.validate()) return;
      this.savingMenu = true;
      const headers = { Authorization: `Bearer ${this.$store.getters.isTokenUser}` };
      try {
        const payload = {
          name: this.menuForm.name,
          route: this.menuForm.route || null,
          parent_id: this.menuForm.parent_id || null,
          icon: this.menuForm.icon || null,
          is_active: this.menuForm.is_active ? 1 : 0,
        };

        if (this.menuFormMode === 'edit') {
          await this.$axios.post(`${process.env.VUE_APP_URL}/api/menus/${this.menuForm.id}`, payload, { headers });
        } else {
          // Menu baru ditaruh di urutan paling akhir pada level (parent) yang sama.
          const siblings = this.menuForm.parent_id
            ? (this.menuTree.find(m => m.id === this.menuForm.parent_id)?.children || [])
            : this.menuTree;
          payload.order = siblings.length;
          await this.$axios.post(`${process.env.VUE_APP_URL}/api/menus`, payload, { headers });
        }

        this.menuDialog = false;
        await this.getMenus();
        this.snackbar = {
          color: 'success', icon: 'mdi-check-circle', mode: null, position: 'top',
          timeout: 2500, title: 'Berhasil', text: 'Menu berhasil disimpan.', visible: true,
        };
      } catch (err) {
        this.snackbar = {
          color: 'error', icon: 'mdi-alert-circle', mode: null, position: 'top',
          timeout: 5000, title: 'Error', text: err.response?.data?.message || 'Gagal menyimpan menu.', visible: true,
        };
      } finally {
        this.savingMenu = false;
      }
    },

  askDeleteMenu(menu) {
      this.menuToDelete = menu;
      this.menuDeleteDialog = true;
    },

  async confirmDeleteMenu() {
      if (!this.menuToDelete) return;
      this.deletingMenu = true;
      try {
        await this.$axios.delete(`${process.env.VUE_APP_URL}/api/menus/${this.menuToDelete.id}`, {
          headers: { Authorization: `Bearer ${this.$store.getters.isTokenUser}` },
        });
        this.menuDeleteDialog = false;
        this.menuToDelete = null;
        await this.getMenus();
        this.snackbar = {
          color: 'success', icon: 'mdi-check-circle', mode: null, position: 'top',
          timeout: 2500, title: 'Berhasil', text: 'Menu berhasil dihapus.', visible: true,
        };
      } catch (err) {
        this.snackbar = {
          color: 'error', icon: 'mdi-alert-circle', mode: null, position: 'top',
          timeout: 5000, title: 'Error', text: err.response?.data?.message || 'Gagal menghapus menu.', visible: true,
        };
      } finally {
        this.deletingMenu = false;
      }
    },

  onDragStart(parentId, index) {
      this.dragState = { parentId, index };
    },

  async onDrop(parentId, toIndex) {
      const state = this.dragState;
      this.dragState = null;
      if (!state || state.parentId !== parentId || state.index === toIndex) return;

      const list = parentId
        ? (this.menuTree.find(m => m.id === parentId)?.children || null)
        : this.menuTree;
      if (!list) return;

      const [moved] = list.splice(state.index, 1);
      list.splice(toIndex, 0, moved);

      await this.persistOrder(list);
    },

  async persistOrder(list) {
      this.savingOrder = true;
      const headers = { Authorization: `Bearer ${this.$store.getters.isTokenUser}` };
      try {
        await Promise.all(
          list.map((item, idx) =>
            this.$axios.post(`${process.env.VUE_APP_URL}/api/menus/${item.id}`, { order: idx }, { headers })
          )
        );
        list.forEach((item, idx) => { item.order = idx; });
      } catch (err) {
        this.snackbar = {
          color: 'error', icon: 'mdi-alert-circle', mode: null, position: 'top',
          timeout: 5000, title: 'Error', text: 'Gagal menyimpan urutan menu.', visible: true,
        };
        await this.getMenus(); // revert ke urutan server kalau gagal
      } finally {
        this.savingOrder = false;
      }
    },

  // ═══════════════════════════════════════════════════════════════
  // ROLE TAB — permission matrix (menu x role)
  // ═══════════════════════════════════════════════════════════════

  roleLabel(role) {
      const labels = { super_admin: 'Super Admin', admin: 'Admin', user: 'User' };
      return labels[role] || role;
    },

  hasMenuRole(menuId, role) {
      return this.menu_roles.some(mr => mr.menu_id === menuId && mr.role === role);
    },

  async toggleMenuRole(menu, role, checked) {
      const key = menu.id + '-' + role;
      this.togglingKey = key;
      const headers = { Authorization: `Bearer ${this.$store.getters.isTokenUser}` };
      try {
        if (checked) {
          const res = await this.$axios.post(`${process.env.VUE_APP_URL}/api/menu-roles`, { menu_id: menu.id, role }, { headers });
          if (res.data.status === 'created' && res.data.menu_role) {
            this.menu_roles.push(res.data.menu_role);
          } else {
            await this.getMenuRole();
          }
        } else {
          const existing = this.menu_roles.find(mr => mr.menu_id === menu.id && mr.role === role);
          if (existing) {
            await this.$axios.delete(`${process.env.VUE_APP_URL}/api/menu-roles/${existing.id}`, { headers });
            this.menu_roles = this.menu_roles.filter(mr => mr.id !== existing.id);
          }
        }
      } catch (err) {
        this.snackbar = {
          color: 'error', icon: 'mdi-alert-circle', mode: null, position: 'top',
          timeout: 5000, title: 'Error', text: 'Gagal mengubah hak akses menu.', visible: true,
        };
        await this.getMenuRole();
      } finally {
        this.togglingKey = null;
      }
    },

  // ═══════════════════════════════════════════════════════════════
  // ICON PICKER — cari & pilih icon dari librari MDI (dipakai form Menu)
  // ═══════════════════════════════════════════════════════════════

  async openIconPicker() {
      this.iconPickerDialog = true;
      if (!this.mdiIconList.length) {
        await this.loadMdiIcons();
      }
    },

  async loadMdiIcons() {
      this.mdiIconsLoading = true;
      try {
        const res = await fetch('https://cdn.jsdelivr.net/npm/@mdi/svg@latest/meta.json');
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        // Simpan aliases & tags juga supaya pencarian sinonim (mis. "user-supervisor"
        // -> nama asli ikonnya "account-supervisor") tetap ketemu, bukan cuma cocok
        // persis dengan nama kanonik ikon.
        this.mdiIconList = data
          .map(i => ({
            name: i.name,
            search: [i.name, ...(i.aliases || []), ...(i.tags || [])].join(' ').toLowerCase(),
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
      } catch (err) {
        console.error('Gagal memuat daftar icon MDI:', err);
        this.snackbar = {
          color: 'error', icon: 'mdi-alert-circle', mode: null, position: 'top',
          timeout: 4000, title: 'Error', text: 'Gagal memuat daftar icon.', visible: true,
        };
      } finally {
        this.mdiIconsLoading = false;
      }
    },

  selectIcon(name) {
      this.menuForm.icon = name;
      this.iconPickerDialog = false;
    },

  // ═══════════════════════════════════════════════════════════════
  // CLONING KPI — salin KPI item dari satu posisi ke posisi lain
  // ═══════════════════════════════════════════════════════════════

  async loadCloningCharts(entityId, target) {
      const chartsKey = target === 'source' ? 'cloningSourceCharts' : 'cloningTargetCharts';
      const loadingKey = target === 'source' ? 'loadingCloningSourceCharts' : 'loadingCloningTargetCharts';
      const selectedKey = target === 'source' ? 'cloningSourceChart' : 'cloningTargetChart';

      this[selectedKey] = null;

      if (!entityId) {
        this[chartsKey] = [];
        return;
      }

      this[loadingKey] = true;
      try {
        const res = await this.$axios.get(`${process.env.VUE_APP_URL}/api/kpi-cloning/charts`, {
          headers: { Authorization: `Bearer ${this.$store.getters.isTokenUser}` },
          params: { entity_id: entityId },
        });
        this[chartsKey] = (res.data.charts || []).map(c => ({
          id: c.id,
          text: c.position_name + ' — ' + (c.user_name || 'Belum diisi'),
        }));
      } catch (err) {
        this[chartsKey] = [];
        this.snackbar = {
          color: 'error', icon: 'mdi-alert-circle', mode: null, position: 'top',
          timeout: 4000, title: 'Error', text: 'Gagal memuat daftar posisi.', visible: true,
        };
      } finally {
        this[loadingKey] = false;
      }
    },

  askConfirmCloning() {
      if (!this.cloningCanSubmit) return;
      this.cloningConfirmDialog = true;
    },

  async confirmCloning() {
      this.cloningConfirmDialog = false;
      this.cloningProcessing = true;
      try {
        const res = await this.$axios.post(
          `${process.env.VUE_APP_URL}/api/kpi-cloning/clone`,
          {
            chart_sumber: this.cloningSourceChart,
            chart_tujuan: this.cloningTargetChart,
            include_target: this.cloningIncludeTarget,
          },
          { headers: { Authorization: `Bearer ${this.$store.getters.isTokenUser}` } }
        );

        this.snackbar = {
          color: 'success', icon: 'mdi-check-circle', mode: null, position: 'top',
          timeout: 5000, title: 'Berhasil', text: res.data.message, visible: true,
        };
        this.cloningSourceChart = null;
        this.cloningTargetChart = null;
      } catch (err) {
        this.snackbar = {
          color: 'error', icon: 'mdi-alert-circle', mode: null, position: 'top',
          timeout: 6000, title: 'Gagal', text: err.response?.data?.message || 'Gagal melakukan cloning KPI.', visible: true,
        };
      } finally {
        this.cloningProcessing = false;
      }
    },

    },
}
</script>



<style scoped>
.activity-log-filters {
  gap: 10px;
  background: #FAFBFC;
}

.detail-field {
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  padding: 6px 10px;
  min-width: 130px;
  max-width: 220px;
}
.detail-field__label {
  font-size: 10.5px;
  font-weight: 600;
  color: #94A3B8;
  text-transform: uppercase;
  letter-spacing: .3px;
  margin-bottom: 3px;
}
.detail-field__value {
  font-size: 12px;
  color: #475569;
  word-break: break-all;
}
.detail-field--changed {
  border-color: #FDE68A;
}
.detail-field__value--old {
  color: #DC2626;
  text-decoration: line-through;
  margin-bottom: 2px;
}
.detail-field__value--new {
  color: #16A34A;
}
.detail-field--created {
  background: #F0FDF4;
  border-color: #BBF7D0;
}
.detail-field--created .detail-field__label {
  color: #16A34A;
}
.detail-field--created .detail-field__value--new {
  color: #166534;
}
.detail-field--deleted {
  background: #FFF5F5;
  border-color: #FECACA;
}
.detail-field--deleted .detail-field__label {
  color: #DC2626;
}
.detail-field--deleted .detail-field__value--old {
  color: #7F1D1D;
  text-decoration: none;
}

.super-admin-dashboard {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 24px;
}

.stat-card {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  transition: transform 0.3s;
}

.stat-card:hover {
  transform: translateY(-5px);
}

.stat-icon {
  position: absolute;
  right: 16px;
  bottom: 16px;
  opacity: 0.3;
  font-size: 48px !important;
}

.main-content {
  border-radius: 12px;
  overflow: hidden;
}

.setup-tabs {
  border-bottom: 1px solid #e0e0e0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.custom-tab {
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0.3px;
  font-size: 0.875rem;
  min-width: 130px;
}
.custom-tab.v-tab--active {
  font-weight: 600;
}

.custom-search {
  max-width: 300px;
}

.custom-table {
  border-radius: 8px;
}

.v-data-table ::v-deep th {
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.v-data-table ::v-deep td {
  font-size: 0.875rem;
}
.v-card-title {
  font-size: 1.25rem;
  font-weight: 500;
}

.v-form {
  margin-top: 8px;
}

.entity-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.dialog-header {
  background: linear-gradient(45deg, var(--v-primary-base), var(--v-primary-lighten2));
  padding: 24px !important;
}

.custom-field {
  margin-bottom: 16px;
}

.v-stepper {
  box-shadow: none;
  background: transparent;
}

.v-stepper__header {
  box-shadow: none;
  border-bottom: 1px solid var(--v-primary-lighten4);
}

.v-stepper__step {
  padding: 24px;
}

.v-stepper__step__step {
  margin-right: 12px;
}

.v-avatar {
  border: 2px solid var(--v-primary-lighten4);
  transition: all 0.3s ease;
}

.v-avatar:hover {
  border-color: var(--v-primary-base);
  transform: scale(1.05);
}

.v-list-item {
  padding: 16px;
}

.v-list-item__subtitle {
  margin-bottom: 4px;
  color: var(--v-primary-base) !important;
}

.v-btn {
  text-transform: none;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.config-section-card {
  transition: box-shadow 0.15s ease;
}
.config-section-card:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08) !important;
}

.eligible-table-wrap {
  border: 1px solid rgba(0, 0, 0, 0.12);
  max-height: 320px;
  overflow-y: auto;
}
.eligible-table >>> table {
  font-size: 0.8125rem;
}
.eligible-table >>> th {
  position: sticky;
  top: 0;
  background: #fafafa;
  z-index: 1;
  font-weight: 600 !important;
}
.eligible-table >>> td,
.eligible-table >>> th {
  height: 36px !important;
  padding: 0 12px !important;
}
.eligible-table >>> tbody tr:nth-child(even) {
  background-color: #fafafa;
}

/* ── Menu tab: tree list + drag-and-drop ── */
.menu-tree__row {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 6px;
  background: #fff;
  transition: box-shadow .15s, border-color .15s;
}
.menu-tree__row:hover {
  border-color: #90caf9;
  box-shadow: 0 2px 8px rgba(33, 150, 243, .12);
}
.menu-tree__handle {
  cursor: grab;
  margin-right: 4px;
}
.menu-tree__children {
  margin-left: 32px;
  padding-left: 12px;
  border-left: 2px solid #e0e0e0;
}
.menu-tree__row--child {
  background: #fafbfc;
}

/* ── Role tab: permission matrix ── */
.role-matrix-wrapper {
  overflow-x: auto;
}
.role-matrix {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}
.role-matrix th,
.role-matrix td {
  border: 1px solid #e0e0e0;
  padding: 8px 12px;
}
.role-matrix thead th {
  background: #f5f5f5;
  font-weight: 600;
  white-space: nowrap;
}
.role-matrix__menu-col {
  text-align: left;
  min-width: 260px;
}
.role-matrix__role-col {
  text-align: center;
  width: 110px;
}
.role-matrix__checkbox {
  display: inline-flex;
  justify-content: center;
}
.role-matrix tbody tr:nth-child(even) {
  background: #fafafa;
}

/* ── Icon picker ── */
.icon-preview-box {
  border: 1px solid #ccc;
}
.icon-picker-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 320px;
  overflow-y: auto;
  padding: 4px 0;
}
.icon-picker-item {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: border-color .15s, background .15s;
}
.icon-picker-item:hover {
  border-color: #2196f3;
  background: #e3f2fd;
}
.icon-picker-item--selected {
  border-color: #1976d2;
  background: #bbdefb;
}

/* ── Cloning KPI tab ── */
.cloning-card {
  border-radius: 10px;
  overflow: hidden;
}
.cloning-card__header {
  color: #fff;
  font-size: 0.95rem;
  font-weight: 600;
  padding: 12px 16px;
}
.cloning-card--source .cloning-card__header--source {
  background: #d32f2f;
}
.cloning-card--target .cloning-card__header--target {
  background: #2e7d32;
}
.cloning-arrow {
  opacity: 0.7;
}
@media (max-width: 960px) {
  .cloning-arrow {
    transform: rotate(90deg);
  }
}
</style>